import { render, staticRenderFns } from "./addJurisdiction.vue?vue&type=template&id=2a1c359c"
import script from "./addJurisdiction.vue?vue&type=script&lang=js"
export * from "./addJurisdiction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports